/**
 * @file PaddleHub 首页 hooks
 * @author FengGuang(fengguang01@baidu.com)
 */
import { useEffect, useState } from 'react';
import { IPaddleHubIndexData } from './types';
import { fetchGetIndex } from '../../api/pages/paddleHubApi';
import { getHubStar } from './../../api/pages/getHubStar';
import useUploadModelModalHooks
    from './components/upload-model-modal/uploadModelModalHooks';


// 预请求
let preRequest: any = {
    fetchGetIndex: fetchGetIndex()
};

const usePaddleHubIndexStore = () => {

    const [hubData, setHubData] = useState<IPaddleHubIndexData>({
        banner: {
            title: '',
            desc: '',
            tags: [],
            btns: [],
            code: ''
        },
        bannerTextCard: [],
        applicationScenarios: {
            title: '',
            subtitle: '',
            group: []
        },
        learnModel: {
            title: '',
            subtitle: '',
            linkMore: {
                label: '',
                href: ''
            },
            list: []
        },
        teaching: {
            title: '',
            subtitle: '',
            linkMore: {
                label: '',
                href: ''
            },
            list: []
        },
        support: {
            title: '',
            subtitle: '',
            list: []
        },
        hubStar: ''
    });

    const [selectedTabKey, setSelectedTabKey] = useState<string>('');

    useEffect(() => {
        (async (): Promise<void> => {
            const fetchFunc = preRequest.fetchGetIndex || fetchGetIndex();
            delete preRequest.fetchGetIndex;
            let res;
            try {
                res = await fetchFunc;
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const theData: any = res.body.result.pageData || {};
                const banner = theData.banner || {};
                const bannerTextCard = theData.bannerTextCard || [];
                const applicationScenarios = theData.applicationScenarios || {};
                const learnModel = theData.learnModel || {};
                const teaching = theData.teaching || {};
                const support = theData.support || {};

                let hubStarNumber: string = '';
                try {
                    let result = await getHubStar();
                    hubStarNumber = '关注量 ' + result.text;
                }
                catch (err: any) {
                    // ignore
                }

                setHubData({
                    banner: {
                        title: banner.title || '',
                        desc: banner.desc || '',
                        tags: banner.tags || [],
                        btns: banner.btns || [],
                        code: banner.code || ''
                    },
                    bannerTextCard,
                    applicationScenarios: {
                        title: applicationScenarios.title || '',
                        subtitle: applicationScenarios.subtitle || '',
                        group: applicationScenarios.group || []
                    },
                    learnModel: {
                        title: learnModel.title || '',
                        subtitle: learnModel.subtitle || '',
                        linkMore: {
                            label: learnModel.linkMore?.label || '',
                            href: learnModel.linkMore?.href || ''
                        },
                        list: learnModel.list || []
                    },
                    teaching: {
                        title: teaching.title || '',
                        subtitle: teaching.subtitle || '',
                        linkMore: {
                            label: teaching.linkMore?.label || '',
                            href: teaching.linkMore?.href || ''
                        },
                        list: teaching.list || []
                    },
                    support: {
                        title: support.title || '',
                        subtitle: support.subtitle || '',
                        list: support.list || []
                    },
                    hubStar: hubStarNumber
                });
            }
        })();
    }, []);

    const uploadModelHooks = useUploadModelModalHooks();

    return {
        selectedTabKey,
        hubData,

        setSelectedTabKey,

        uploadModelHooks
    };
};

export default usePaddleHubIndexStore;
